import { useAction, useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import { useMemo } from 'use-memo-one'

import { CircularLoader, Refresh2Icon } from '@blade/ui-kit'
import { reatomRefreshWallet } from '@root/features/wallet/refresh-wallet'

import { EditWalletPanelItem } from './edit-wallet-panel-item'

import type { WalletModel } from '@root/entities/wallet'

type Props = {
  wallet: WalletModel
}

export const EditWalletRefresh: React.FC<Props> = ({ wallet }) => {
  const { t } = useTranslation()

  const refreshRequestAtom = useMemo(
    () =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomRefreshWallet({ walletId: wallet.id }),
    [wallet.id],
  )
  const [refreshRequestState] = useAtom(refreshRequestAtom)
  const refreshWallet = useAction(refreshRequestAtom.execute)

  return (
    <EditWalletPanelItem
      icon={<Refresh2Icon size={16} />}
      endContent={
        refreshRequestState.loading ? <CircularLoader size={12} /> : undefined
      }
      title={t('wallet.refresh-wallet')}
      onClick={refreshWallet}
    />
  )
}
